var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppHorizontalList',{attrs:{"items":_vm.products},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('n-link',{attrs:{"to":_vm.localePath({
          name: 'ville-boutique-subCategory-product',
          params: _vm.getParams(item)
        })}},[_c('ProductExerpt',{attrs:{"product":item}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }